import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import translationEN from './en/translation.json';

export const defaultNS = 'ns1';

// the translations
export const resources = {
	en: {
		ns1: translationEN
	}
} as const;

i18n.use(initReactI18next) // passes i18n down to react-i18next
	.init({
		resources,
		lng: 'en',
		ns: ['ns1'],
		interpolation: {
			escapeValue: false, // react already safes from xss
			prefix: '${',
			suffix: '}'
		}
	});

export default i18n;
